import styled from 'styled-components';

import {colorVar} from '../../Theme/colors';
import AbsLayer from './AbsLayer';

const OutlineDisabledBaseLayer = styled(AbsLayer)`
  border: solid var(--theme-border-thickness) ${colorVar('onSurface')};
  opacity: 0.12;
`;

export default OutlineDisabledBaseLayer;
